import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path d="M16.2 2.25a.75.75 0 0 0 0 1.5h2.99l-4.72 4.72a.75.75 0 0 0 1.06 1.06l4.72-4.72V7.8a.75.75 0 0 0 1.5 0V3a.75.75 0 0 0-.75-.75zM9.53 15.53a.75.75 0 1 0-1.06-1.06l-4.72 4.72V16.2a.75.75 0 0 0-1.5 0V21c0 .414.336.75.75.75h4.8a.75.75 0 0 0 0-1.5H4.81z" />
  </>
);

const Expand = Icon('expand', svgContents);

export default Expand;
